import { RefillStep, RefillStyle } from 'app/dataTypes/acquiring/settings'

import { getIsReturnLinkAvailable } from './getIsReturnLinkAvailable'

export const getIsNoSpaceForBanner = (
  refillStep: RefillStep | null,
  refillStyle: RefillStyle | null,
) => {
  return getIsReturnLinkAvailable(refillStep, refillStyle)
}
